<template>
  <div v-if="!isContactPage">
    <v-fab
      :icon="showCTASheet ? 'mdi-close' : 'mdi-message-alert'"
      data-testid="fab-stub"
      size="large"
      location="right bottom"
      :color="showCTASheet ? 'grey-darken-3' : 'primary'"
      app
      @click="showCTASheet = !showCTASheet"
    />

    <v-bottom-sheet
      v-model="showCTASheet"
      :persistent="persistentCTASheet"
    >
      <ContactLeadForm @submitted="showThankYou" />
    </v-bottom-sheet>
  </div>
  <v-snackbar
    v-model="thankYou"
    :timeout="3500"
    top
    color="success"
    class="text-h4"
  >
    🎉 Thank you! We’ve received your request.
  </v-snackbar>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue';
  import { useRoute } from 'vue-router';
  import ContactLeadForm from './ContactLeadForm.vue';

  type ReferrerTypes = 'linkedIn' | 'searchAd' | 'unknown';
  function getReferrer() {
    let referrerType: ReferrerTypes = 'unknown';
    const referrer = document.referrer.toLowerCase();

    if (referrer.includes('linkedin.com') || route.query.utm_source === 'linkedin') {
      referrerType = 'linkedIn';
    } else if (referrer.includes('google.com') || route.query.utm_source === 'google') {
      referrerType = 'searchAd';
    }

    return referrerType;
  }

  const thankYou = ref(false);

  function showThankYou() {
    thankYou.value = true;
    showCTASheet.value = false;
  }

  const route = useRoute();
  const isContactPage = computed(
    () =>
      route.name ===
      // Coupled (TAG: F83ABD412A85474CAF953FB4C5C68CA9)
      'contact'
  );

  const showCTASheet = ref<boolean>(false);
  const persistentCTASheet = ref<boolean>(false);

  setTimeout(() => {
    if (getReferrer() === 'linkedIn') {
      showCTASheet.value = true;
      persistentCTASheet.value = true;
    }
  }, 500);
</script>
